/** @jsx jsx */
import {jsx} from 'theme-ui'
import type {DonationItem} from './AccountContent'
import {useMemo, Fragment} from 'react'
import Table from './Table'

type RowItem = {
  index: number
  purpose: string
  type: string
  amount: number
  date: Date
  payment_gateway: 'STRIPE' | 'PAYPAL'
}

const columns: {
  id: keyof RowItem
  label: string
  minWidth: number
  align?: 'left' | 'right' | 'center'
  format?: (source: any) => string
}[] = [
  {
    id: 'date',
    label: 'Date',
    minWidth: 100,
    format: (date: Date) => date.toLocaleDateString(),
  },
  {
    id: 'type',
    label: 'Type',
    minWidth: 140,
  },
  {
    id: 'payment_gateway',
    label: 'Method',
    minWidth: 120,
    // TODO use translate
    format: (payment_gateway: 'STRIPE' | 'PAYPAL') =>
      payment_gateway === 'STRIPE' ? 'Credit Card' : 'PayPal',
  },
  {
    id: 'purpose',
    label: 'Cause',
    minWidth: 140,
  },
  {
    id: 'amount',
    label: 'Amount (USD)',
    minWidth: 100,
    align: 'right',
    format: (amount: number) => `$${amount}`,
  },
]

type Props = {
  donations: DonationItem[]
  totalText: string
}

const AccountDonations: React.FC<Props> = ({donations, totalText}) => {
  const tableItems = useMemo(() => {
    return donations.map((donation, index) => {
      return {
        index: index + 1,
        purpose: donation.charity_organization,
        amount: donation.amount,
        date: new Date(donation.created_at),
        type: donation.monthly ? 'Monthly' : 'One time',
        subscriptionId: donation.subscription_id,
        payment_gateway: donation.payment_gateway,
      }
    })
  }, [donations])
  const totalDonations = useMemo(
    () =>
      donations.reduce((acc, {amount}) => {
        acc += amount
        return acc
      }, 0),
    [donations],
  )
  return (
    <Fragment>
      <Table columns={columns} items={tableItems} />
      {totalDonations > 0 && (
        <p
          sx={{
            mt: 30,
            fontSize: 20,
          }}
        >
          {totalText} ${totalDonations} USD.
        </p>
      )}
    </Fragment>
  )
}

export default AccountDonations
